// The question is whether anybody was there recently, not how much they did — so one
// report per window is all that is worth sending.

export const BEAT_COALESCE_MS = 30_000;

export function shouldEmit(lastEmittedAt: number | null, now: number): boolean {
  return lastEmittedAt === null || now - lastEmittedAt >= BEAT_COALESCE_MS;
}

// How long the SDR has left, as the prompt says it. Floor, not round: a deadline that
// reads 1:00 with 59.6s left overstates the time somebody has to act on it.
export function remainingLabel(expiresAt: string, now: number): string {
  const ms = Date.parse(expiresAt) - now;
  if (!Number.isFinite(ms) || ms <= 0) return '0:00';
  const seconds = Math.floor(ms / 1000);
  return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
}
